
import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Helper } from '../common/helpers/Helper';
import { CustomAssetPickerStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { AppTheme } from '../styles/AppTheme';
import { AssetsCollection } from './AssetsCollection';
import { AppUiHelper } from '../helpers/AppUiHelper';

export class AssetPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAssetPicker: false
    }
    this.currentSelectedAssets = this.props.assetsDetails ? this.props.assetsDetails : null
  }
  openAssetPicker = (e) => {
    this.setState({
      showAssetPicker: true
    })
  }
  listThumbnail = (item) => {
    if (item.iType === 'VIDEO') {
      return AppUiHelper.renderVideoThumbnailCustomStyle(item)
    } else if (item.iType === 'WEBLINK') {
      return (<i alt={Helper.getString('assetImageAlt')} className={'icons material-icons-outlined ' + css(Styles.icons)} >http</i>)
    } else {
      return (
        <img alt={Helper.getString('assetImageAlt')}  src={item.content} className={css(Styles.assetsImageContent)} />
      )
    }
  }
  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.outerMainContainer)}>
          {(this.currentSelectedAssets && // Assets Preview -------
            <div className={css([Styles.assetPicketOuterContainer, Styles.imageOuterContainer])}>
              <label className={css(Styles.labelContainer)}>
                {this.listThumbnail(this.currentSelectedAssets)}
                <span className={css(Styles.selectedItemsTitle)}>{this.currentSelectedAssets.contentName}</span>
              </label>
              <div className={this.props.disabled ? css([Styles.closeIconContainer, Styles.closeIconDisableContainer, Styles.deleteIconContainer]) : css([Styles.closeIconContainer, Styles.deleteIconContainer])}
                onClick={() => !this.props.disabled && this.clearSelectedAssets()}>
                <i className='material-icons-outlined' style={{ fontSize: 14 }}>delete</i>
              </div>
            </div>
          )}
          <div disabled={this.props.disabled} onClick={(e) => !this.props.disabled && this.openAssetPicker(e)} className={this.props.disabled ? css([Styles.assetPickerContainer, Styles.assetPickerContainerDisabled]) : css(Styles.assetPickerContainer)}>
            <p className={css(Styles.assetPickerTitle)}>{Helper.getString('mediaPickerTitle')}</p>
          </div>
        </div>
        <AssetsCollection
          orgId={this.props.orgId}
          onAssetSelectionComplete={this.onAssetSelectionComplete.bind(this)}
          isOpen={this.state.showAssetPicker}
          onClosed={() => this.setState({ showAssetPicker: false })}
        />
      </div>
    )
  }

  async onAssetSelectionComplete(selectedMediaInfo) {
    this.currentSelectedAssets = selectedMediaInfo
    if (this.props.onSelectSuccess) {
      this.props.onSelectSuccess(this.props.updateField, selectedMediaInfo)
    }
  }
  clearSelectedAssets = () => {
    this.currentSelectedAssets = null
    const selectedMediaInfo = {
      fields:  {
        key: ''
      }
    }
    this.props.onSelectSuccess(this.props.updateField,selectedMediaInfo)
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('AssetPicker')) ? CustomAssetPickerStyles : StyleSheet.create({
  container: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  text: {
    marginTop: 10,
    marginBottom: 3,
    fontSize: 12
  },
  textSuccess: {
    color: 'green',
  },
  closeIconContainer: {
    backdropFilter: 'blur(6px)',
    backgroundColor: 'white',
    display: 'flex',
    cursor: 'pointer',
    border: '1px solid black',
    padding: 2,
    borderRadius: 4,
  },
  closeIconDisableContainer: {
    backgroundColor: '#f5f5f5',
    cursor: 'default',
  },
  labelContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    padding: 0,
    borderRadius: 0,
    alignItems: 'center'
  },
  outerMainContainer: {
    display: 'flex'
  },
  imageOuterContainer: {
    // flex: 'unset',
    border: '1px solid #E5E5E5'
  },
  deleteIconContainer: {
    margin: '0px 5px'
  },
  assetPicketOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px dashed #E5E5E5',
    borderRadius: AppTheme.borderRadius,
    height: 49,
    position: 'relative',
    overflow: 'hidden',
    marginRight: 10
  },
  assetPickerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'whitesmoke',
    flex: '1 1 0%',
    padding: 0,
    cursor: 'pointer',
    borderRadius: AppTheme.borderRadius,
    maxWidth: 125,
    minHeight: 51
  },
  assetPickerTitle: {
    textAlign: 'center',
    fontSize: 12
  },
  selectedItemsTitle: {
    fontSize: '10px !important',
    maxWidth: '120px !important',
    padding: '0px 10px !important',
    textOverflow: 'ellipsis !important',
    overflow: 'hidden',
    lineBreak: 'anywhere',
    whiteSpace: 'nowrap'
  },
  assetsImageContent: {
    borderRadius: 15,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    marginLeft: 1
  },
  icons:{
    color: 'lightgray',
    padding: '0px 12px'
  }
})



// WEBPACK FOOTER //
// ./src/components/AssetPicker.js